import { useLanguage } from '../../i18n/LanguageContext';

/** Why a spend action is disabled for staff without canCommitSpend (BR-6). */
export default function CommitSpendNote() {
  const { t } = useLanguage();
  return <p className="dealer-note dealer-note--warn" role="note">{t('dealer.commit.disabledReason')}</p>;
}
